import { IResponseList } from './response-list.interface';
import { IFilterPayload, IPagingPayload, ISortPayload } from './common-api-payloads.interface';
import { IRunningShipmentPayload } from './running-shipment-payload.interface';
import { UpdateWaitingChargeConfigDto } from './waiting-charge-config-update.dto';

export { IFilterPayload, IPagingPayload, ISortPayload, IResponseList, IRunningShipmentPayload, UpdateWaitingChargeConfigDto };
